export default __webpack_public_path__ + "static/media/372.b30ea04a.png";